// 负责维护学习版商品种子数据，与目录、购物车和后续数据库迁移关联。
import type { Product } from "./types";

export const products: Product[] = [
  {
    id: "linen-midi-dress",
    name: "Linen Tie-Back Midi Dress",
    category: "Dresses",
    price: 68,
    compareAtPrice: 92,
    imageUrl:
      "https://images.unsplash.com/photo-1515372039744-b8f02a3ae446?auto=format&fit=crop&w=1200&q=80",
    color: "Oat linen",
    sizes: ["XS", "S", "M", "L"],
    tags: ["Vacation", "Bestseller"],
    fitNote: "Relaxed waist with adjustable back tie.",
    material: "55% linen, 45% viscose"
  },
  {
    id: "rib-knit-tank",
    name: "Rib Knit Square-Neck Tank",
    category: "Tops",
    price: 29,
    imageUrl:
      "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?auto=format&fit=crop&w=1200&q=80",
    color: "Ink black",
    sizes: ["XS", "S", "M", "L", "XL"],
    tags: ["Core", "Layering"],
    fitNote: "Close fit with medium stretch.",
    material: "92% cotton, 8% elastane"
  },
  {
    id: "cropped-trench",
    name: "Cropped Water-Resistant Trench",
    category: "Outerwear",
    price: 118,
    compareAtPrice: 148,
    imageUrl:
      "https://images.unsplash.com/photo-1496747611176-843222e1e57c?auto=format&fit=crop&w=1200&q=80",
    color: "Stone khaki",
    sizes: ["S", "M", "L"],
    tags: ["Travel", "New"],
    fitNote: "Boxy cropped shape, size down for a closer look.",
    material: "Recycled polyester shell"
  },
  {
    id: "soft-tailored-set",
    name: "Soft Tailored Two-Piece Set",
    category: "Sets",
    price: 96,
    imageUrl:
      "https://images.unsplash.com/photo-1485968579580-b6d095142e6e?auto=format&fit=crop&w=1200&q=80",
    color: "Sage green",
    sizes: ["XS", "S", "M", "L"],
    tags: ["Workwear", "Set"],
    fitNote: "Straight leg trouser with lightly structured vest.",
    material: "Tencel blend suiting"
  },
  {
    id: "satin-wrap-blouse",
    name: "Satin Wrap Blouse",
    category: "Tops",
    price: 46,
    imageUrl:
      "https://images.unsplash.com/photo-1543087903-1ac2ec7aa8c5?auto=format&fit=crop&w=1200&q=80",
    color: "Rose clay",
    sizes: ["XS", "S", "M", "L"],
    tags: ["Date night", "Low stock"],
    fitNote: "True to size with adjustable side tie.",
    material: "Naia acetate satin"
  },
  {
    id: "column-maxi-dress",
    name: "Column Knit Maxi Dress",
    category: "Dresses",
    price: 74,
    imageUrl:
      "https://images.unsplash.com/photo-1529139574466-a303027c1d8b?auto=format&fit=crop&w=1200&q=80",
    color: "Marigold",
    sizes: ["S", "M", "L", "XL"],
    tags: ["Occasion", "Stretch"],
    fitNote: "Body-skimming column with side slit.",
    material: "Viscose nylon knit"
  }
];
